export const ALLOWED_FILE_TYPES = [
  'cover_letter',
  'letter_of_recommendation',
  'certificate_degree',
  'resume',
  'document_passport',
  'drivers_license',
  'portfolio'
];

export const ALLOWED_STATUSES = { disabled: 0, required: 1, optional: 2 };

export const MAX_FILE_SIZE = 15 * 1024 * 1024; // 15MB en bytes
export const FORMAT_FILES_ACCEPTED = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg'];

export const MIME_TO_EXTENSION = {
  'application/pdf': ['pdf'],
  'application/msword': ['doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['docx'],
  'image/jpeg': ['jpg', 'jpeg']
};
